import { z } from 'zod';
/**
 * Auth contracts, per PRD VS-001/VS-002 and TechSpec §13.1.
 *
 * Web clients never see the refresh token: it travels only in the httpOnly
 * cookie. Desktop clients receive it in the body so it can go to Stronghold.
 */
export const AUTH_CLIENTS = ['web', 'desktop'];
export const UsernameSchema = z.string().trim().toLowerCase().min(1).max(64);
export const TotpCodeSchema = z.string().regex(/^\d{6}$/);
export const LoginRequestSchema = z.object({
    username: UsernameSchema,
    password: z.string().min(1).max(1024),
    totp: TotpCodeSchema,
    client: z.enum(AUTH_CLIENTS).default('web'),
});
export const RefreshRequestSchema = z.object({
    client: z.enum(AUTH_CLIENTS).default('web'),
    /** Desktop only. Web sends the cookie instead. */
    refreshToken: z.string().min(1).max(512).optional(),
});
export const LogoutRequestSchema = z.object({
    /** Desktop only. Web sends the cookie instead. */
    refreshToken: z.string().min(1).max(512).optional(),
});
export const SessionUserSchema = z.object({
    id: z.string().uuid(),
    username: z.string(),
});
export const TokenResponseSchema = z.object({
    accessToken: z.string(),
    /** Seconds until the access token expires. */
    expiresIn: z.number().int().positive(),
    user: SessionUserSchema,
    /** Present only for `client: 'desktop'`. */
    refreshToken: z.string().optional(),
});
export const MeResponseSchema = z.object({
    id: z.string().uuid(),
    username: z.string(),
    totpEnabled: z.boolean(),
    createdAt: z.string(),
    lastLoginAt: z.string().nullable(),
});
//# sourceMappingURL=auth.js.map